import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";
import {getProgramCard} from "../../../ManageOOP/Resources/OpMod/MyOPMod/api/programs";
import {getProgramBlocks, getProgramAuthors, getAllProgramModules} from "./actions";

//! CHANGE PROGRAM INFORMATION
export function changeProgramInfoAction(programInfo) {
  return {
    type: types.CHANGE_PROGRAM_INFORMATION,
    programInfo
  };
}

export function clearProgramCreatedAction() {
  return {
    type: types.CREATE_CONSTRUCTOR_PROGRAM_COMPLETED,
    isProgramCreating: false,
    createdProgram: null
  };
}

function createProgramRequest() {
  return {
    type: types.CREATE_CONSTRUCTOR_PROGRAM_REQUEST,
    isProgramCreating: true
  };
}

function createProgramCompleted(createdProgram) {
  return {
    type: types.CREATE_CONSTRUCTOR_PROGRAM_COMPLETED,
    isProgramCreating: false,
    createdProgram
  };
}

function createProgramError(programCreatingError) {
  return {
    type: types.CREATE_CONSTRUCTOR_PROGRAM_ERROR,
    isProgramCreating: false,
    programCreatingError
  };
}

export function createConstructorProgram() {
  return dispatch => {
    dispatch(createProgramRequest());
    return api.createProgramDraft()
      .then(response => {
        if (response.status === 200) {
          dispatch(createProgramCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createProgramError(message));
        } else {
          logError(err);
          dispatch(createProgramError(createError("Не удалось отправить запрос на создание программы")));
        }
      });
  };
}

function updateProgramRequest() {
  return {
    type: types.UPDATE_CONSTRUCTOR_PROGRAM_REQUEST,
    isProgramUpdating: true
  };
}

function updateProgramCompleted(updatedProgram) {
  return {
    type: types.UPDATE_CONSTRUCTOR_PROGRAM_COMPLETED,
    isProgramUpdating: false,
    updatedProgram
  };
}

function updateProgramError(programUpdatingError) {
  return {
    type: types.UPDATE_CONSTRUCTOR_PROGRAM_ERROR,
    isProgramUpdating: false,
    programUpdatingError
  };
}

export function updateConstructorProgram(id, data) {
  return dispatch => {
    dispatch(updateProgramRequest());
    return api.updateProgram(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateProgramCompleted(response.data));
          //dispatch(getProgramCard(id));
          logSuccess("Данные успешно обновлены");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateProgramError(message));
        } else {
          logError(err);
          dispatch(updateProgramError(createError("Не удалось отправить запрос на обновление данных программы")));
        }
      });
  };
}

function createBlockRequest() {
  return {
    type: types.CREATE_BLOCK_PROGRAM_REQUEST,
    fetchingAddProgramBlock: true
  };
}

function createBlockCompleted(createdProgramBlock) {
  return {
    type: types.CREATE_BLOCK_PROGRAM_COMPLETED,
    fetchingAddProgramBlock: false,
    createdProgramBlock
  };
}

function createBlockError(fetchingAddProgramBlockError) {
  return {
    type: types.CREATE_BLOCK_PROGRAM_ERROR,
    fetchingAddProgramBlock: false,
    fetchingAddProgramBlockError
  };
}

export function createProgramBlock(id, data) {
  return dispatch => {
    dispatch(createBlockRequest());
    return api.addBlock(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(createBlockCompleted(response.data));
          dispatch(getProgramBlocks(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createBlockError(message));
        } else {
          logError(err);
          dispatch(createBlockError(createError("Не удалось отправить запрос на удаление блока")));
        }
      });
  };
}

function updateBlockRequest() {
  return {
    type: types.UPDATE_BLOCK_PROGRAM_REQUEST,
    fetchingUpdateProgramBlock: true
  };
}

function updateBlockCompleted(updatedProgramBlock) {
  return {
    type: types.UPDATE_BLOCK_PROGRAM_COMPLETED,
    fetchingUpdateProgramBlock: false,
    updatedProgramBlock
  };
}

function updateBlockError(fetchingUpdateProgramBlockError) {
  return {
    type: types.UPDATE_BLOCK_PROGRAM_ERROR,
    fetchingUpdateProgramBlock: false,
    fetchingUpdateProgramBlockError
  };
}

export function updateProgramBlock(id, blockId, data) {
  return dispatch => {
    dispatch(updateBlockRequest());
    return api.updateBlock(id, blockId, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateBlockCompleted(response.data));
          dispatch(getProgramBlocks(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateBlockError(message));
        } else {
          logError(err);
          dispatch(updateBlockError(createError("Не удалось отправить запрос на обновление блока")));
        }
      });
  };
}

function changeStatusRequest() {
  return {
    type: types.SEND_PROGRAM_APPROVE_REQUEST,
    changingProgramStatus: true
  };
}

function changeStatusCompleted(changedProgramStatus) {
  return {
    type: types.SEND_PROGRAM_APPROVE_COMPLETED,
    changingProgramStatus: false,
    changedProgramStatus
  };
}

function changeStatusError(changingProgramStatusError) {
  return {
    type: types.SEND_PROGRAM_APPROVE_ERROR,
    changingProgramStatus: false,
    changingProgramStatusError
  };
}

export function sendProgramToExpertise(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "sendToExpertise")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа отправлена на экспертизу")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось отправить программу на экспертизу")));
        }
      });
  };
}

export function approveProgramExpertise(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "approveExpertise")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа одобрена экспертом")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось одобрить программу")));
        }
      });
  };
}

export function rejectProgramExpertise(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "rejectExpertise")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа отклонена экспертом")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось отклонить программу")));
        }
      });
  };
}

export function sendProgramToDevelop(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "sendToDevelop")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа отправлена на доработку")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось отправить программу на доработку")));
        }
      });
  };
}

export function sendProgramToPublication(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "sendToPublication")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа отправлена на публикацию")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось отправить программу на публикацию")));
        }
      });
  };
}

export function approveProgramPublication(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "approvePublication")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Программа успешно опубликована")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось опубликовать программу")));
        }
      });
  };
}

export function rejectProgramPublication(id, comment) {
  return dispatch => {
    dispatch(changeStatusRequest());
    return api.changeExpertiseStatus(id, comment, "rejectPublication")
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatusCompleted(response.data));
          logSuccess("Публикация программы отклонена")
        } else { return Promise.reject(response); }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(changeStatusError(message));
        } else {
          logError(err);
          dispatch(changeStatusError(createError("Не удалось отклонить публикацию программу")));
        }
      });
  };
}

function changeAuthorsRequest() {
  return {
    type: types.SEND_PROGRAM_AUTHORS_REQUEST,
    changingProgramAuthors: true
  };
}

function changeAuthorsCompleted(changedAuthors) {
  return {
    type: types.SEND_PROGRAM_AUTHORS_COMPLETED,
    changingProgramAuthors: false,
    changedAuthors
  };
}

function changeAuthorsError(changingAuthorsError) {
  return {
    type: types.SEND_PROGRAM_AUTHORS_ERROR,
    changingProgramAuthors: false,
    changingAuthorsError
  };
}

export function changeProgramAuthors(data) {
  return dispatch => {
    dispatch(changeAuthorsRequest());
    return api.editAuthors(data)
      .then(response => {
        if (response.status === 200) {
          dispatch(changeAuthorsCompleted(response.data));
          dispatch(getProgramAuthors(data.program))
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(changeAuthorsError(message));
        } else {
          logError(err);
          dispatch(changeAuthorsError(createError("Не удалось изменить составителей программы")));
        }
      });
  };
}

function includeModuleRequest() {
  return {
    type: types.ADD_MODULE_PROGRAM_REQUEST,
    fetchingAddProgramModule: true
  };
}

function includeModuleCompleted(createdProgramModule) {
  return {
    type: types.ADD_MODULE_PROGRAM_COMPLETED,
    fetchingAddProgramModule: false,
    createdProgramModule
  };
}

function includeModuleError(fetchingAddProgramModuleError) {
  return {
    type: types.ADD_MODULE_PROGRAM_ERROR,
    fetchingAddProgramModule: false,
    fetchingAddProgramModuleError
  };
}

export function includeProgramModule(id, data) {
  return dispatch => {
    dispatch(includeModuleRequest());
    return api.includeModule(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(includeModuleCompleted(response.data));
          dispatch(getAllProgramModules(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(includeModuleError(message));
        } else {
          logError(err);
          dispatch(includeModuleError(createError("Не удалось отправить запрос на добавление модуля")));
        }
      });
  };
}

export default {
  changeProgramInfoAction,
  clearProgramCreatedAction,
  createConstructorProgram,
  updateConstructorProgram,
  updateProgramBlock,
  createProgramBlock,
  includeProgramModule,
  sendProgramToExpertise,
  sendProgramToDevelop,
  sendProgramToPublication,
  approveProgramExpertise,
  rejectProgramExpertise,
  approveProgramPublication,
  rejectProgramPublication,
  changeProgramAuthors
}
